import React from "react";
import PropTypes from "prop-types";

import "./ActionPromptButton.scss";

const ActionPromptButton = ({ buttonType, onClick, label }) => (
	<button
		className={`messenger-action-prompt-action messenger-action-prompt-action--${buttonType}`}
		onClick={onClick}
	>
		{label}
	</button>
);

ActionPromptButton.buttonType = {
	default: "default",
	primary: "primary",
	secondary: "secondary",
};

ActionPromptButton.propTypes = {
	buttonType: PropTypes.oneOf(Object.values(ActionPromptButton.buttonType)).isRequired,
	onClick: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
};

export default ActionPromptButton;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/MessagePane/ActionPromptButton.jsx